import english from './english';
import german from './german';

export default { english, german };
